import secureLocalStorage from "react-secure-storage";
import { CircularProgress } from "@material-ui/core";
import { drawDOM, exportImage, exportPDF } from "@progress/kendo-drawing";
import { saveAs } from "@progress/kendo-file-saver";
import { Window } from "@progress/kendo-react-dialogs";
import { Popup } from "@progress/kendo-react-popup";
import { formatNumber } from "@telerik/kendo-intl";
import "hammerjs";
import * as moment from "moment";
import React, { Component, PureComponent } from "react";
import { toastr } from "react-redux-toastr";
import Images from "../../Assets/Images";
import Api from "../../Services/Api";
import HistogramChart from "./HistogramChart";
import TornadoChart from "./TornadoChart";
import FullTornadoChart from "./FullTornadoChart";
import ViewActionRiskDataset from "./ViewActionRiskDataset";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import TextNarrative from "./TextNarrative"
import AddToCart from "../Tenant/AddToCart";
import { Dropdown } from "react-bootstrap";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import SkeletonReport from "./SkeletonReport";
import ReportUpdate from "./ReportUpdate";



const theme = createMuiTheme({
  palette: {
     secondary: {
         main: '#009660'
     }
  }
})
export default class BarChartContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emailId: "",
      message: "",
      projectHomeFlag: false,
      openPdfTitlePopup: false,
      title: "",
      showAddToCart: false,
      visible: false,
      emailloader:false,
      loader:false,
      isReportLoaded:false,
      chartData:{}
    };
    this._exporterBarChart = React.createRef();
    
  }
  componentDidMount=()=>{
    if(this.props.dashboardId&&this.props.reportId&&!this.props.chartInputs){
      this.fetchReportsByPagination(this.props.dashboardId,this.props.reportId);
    }else{
      this.setState({
        chartData:this.props.chartInputs ? this.props.chartInputs : {},
        isReportLoaded:true
      });
    }   }
   fetchReportsByPagination = async (dashboardId, reportId) => {
    try {
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        DashBoardId: parseInt(dashboardId),
        WidgetListIds: [reportId],
      };
      let response = await Api.getReportsByDashboardID(request);
      if (response.status === 200 && response.chartData) {
        this.setState({
          chartData:response.chartData[0],
          isReportLoaded:true
        });
        this.props.updateResponse(reportId,response.chartData[0]);
      }else{
        this.setState({
          chartData:{},
          isReportLoaded:true
        });
      }
    } catch (error) {
      console.error(error);
      this.setState({
        chartData:{},
        isReportLoaded:true
      });
    }
  };
  openAddToCart(data) {
    this.setState({
      showAddToCart: true,
      cartViewDetails: data,
      cartViewType: "Widget",
    });
  }
  closeAddToCart() {
    this.setState({ showAddToCart: false });
  }

  openWidgetDeletePopup = () => {
    if(!this.props.isFreezeDS){
      this.setState({
        ...this.state,
        openDeleteModelFlag: true,
      });
    }
  };
  closeWidgetDeletePopup = () => {
    this.setState({
      ...this.state,
      openDeleteModelFlag: false,
    });
  };

  removeWidget = async (data) => {
    try {
      const requestParams = {
        DeletedBy: data.widgetId||this.props.reportId,
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.deleteWidget(requestParams);
      if (response.status === 200) {
        this.setState({ ...this.state, loader: false });
        toastr.success(response.message);
        this.closeWidgetDeletePopup();
        this.props.selectedDB(true);
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };

  changeLineChartWidth = (widgetId) => {
    this.props.changeLineChartWidth(widgetId);
  };

  editWidget = (data) => {
    if (data.isActionWidget) {
      this.refs.childWidget.editWidgetdOpen("MITI", data);
    } else {
      this.refs.childWidget.editWidgetdOpen("RISK", data);
    }
  };

  selectedDB = (data) => {
    this.props.selectedDB(data);
  };

  shareFile =async (widgetId) => {
    try{
      let chartId = this.state.chartData.widgetId;
      let widgetName = this.state.chartData
        ? this.state.chartData.widgetName
        : "Histogram";
      const pdf = new jsPDF("pt", "mm",'a4');
      let ids = [
        "c1" + chartId,
        "c2" + chartId,
        "c3" + chartId,
        "c4" + chartId
      ];
      for (let i = 0; i < ids.length; i++) {
        const input = document.getElementById(ids[i]),
          canvas = await html2canvas(input);
        const imgData = canvas.toDataURL("image/png");
        pdf.addPage();
        pdf.setFillColor(24,26,26);
        pdf.rect(0, 0, 210, 300, "F")
        pdf.addImage(imgData, "PNG",40,30);

      }
      pdf.deletePage(1);
      // pdf.save(widgetName+".pdf");
      var base = pdf.output("datauristring"); // base64 string
      // console.log("base64 is ", base);
      // let base64URI = base.split(";base64,")[1];
      console.log(base);
       this.sendMail(base, widgetId);
    }catch(err){
      console.error(err);
    }
  };

  sendMail = async (dataURL, widgetId) => {
    try{
      let widgetName = this.state.chartData
      ? this.state.chartData.widgetName
      : "Bar-chart";
    const CreatedDate = moment(new Date()).format("YYYY-MM-DD hh:mm:ss");

    var file = this.dataURLtoFile(dataURL, widgetName + ".pdf");
    var fd = new FormData(document.forms[0]);
    fd.append("file", file);
    fd.append("mailId", this.state.emailId);
    fd.append("message", this.state.message);
    fd.append("widgetId", widgetId);
    fd.append("createdby", parseInt(secureLocalStorage.getItem("loginUserId")));
    fd.append("CreatedDate", CreatedDate);
    fd.append("name", secureLocalStorage.getItem("userName"));
    fd.append("TenantKey", secureLocalStorage.getItem("tenantKey"));
    // this.setState({ ...this.state, loader: true });
    let response = await Api.shareWidgetToUser(fd);
    if (response.status === 200) {
      this.setState({ ...this.state,  emailId: "", message: "" });
      toastr.success(response.message);
    } else {
      // this.setState({ ...this.state, loader: false });
      toastr.error(response.message);
    }
    }catch(err){
      console.error(err);
    }
    
  };

  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  moveToHome = async (data) => {
    try {
      var req = {
        Enable: true,
        WidgetId: data.widgetId,
        CreatedBY: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.WidgetHome(req);
      if (response.status === 200) {
        this.setState({ ...this.state, loader: false });
        toastr.success(response.message);
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };

  pdfTitlePopupClose = () => {
    setTimeout(() => {
      this.setState({
        ...this.state,
        openPdfTitlePopup: false,
        title: "",
        isHidden: false,
      });
    }, 1000);
  };
  pdfTitlePopupOpen = () => {
    this.setState({
      ...this.state,
      openPdfTitlePopup: true,
      isHidden: true,
    });
  };
  refreshDashboard = (flag) => {
    this.props.refreshDashboard(flag);
  };
  ViewDataSet = () => {
    this.setState({
      visible: true,
    });
  };
  closeToggleClose = () => {
    this.setState({
      visible: false,
    });
  };
  formatYaxisValue = (e) => {
    if (this.isFloat(e.value)) {
      return "";
    } else {
      return formatNumber(Number(e.value), "##,#");
    }
  };
  isFloat(n) {
    return Number(n) === n && n % 1 !== 0;
  }
  handleDownloadImage = async () => {

    try {
      this.setState({ ...this.state, emailloader: true });
      let chartId = this.state.chartData.widgetId;
      let htmlId = "cg" + chartId;
      let widgetName = this.state.chartData
        ? this.state.chartData.widgetName
        :"Histogram";
       
      const element = document.getElementById(htmlId),
        canvas = await html2canvas(element),
        data = canvas.toDataURL("image/png"),
        link = document.createElement("a");

      link.href = data;
      link.download = widgetName + ".png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.setState({ ...this.state, emailloader: false });
    } catch (err) {
      console.error(err);

      this.setState({ ...this.state, emailloader: false });
    }
  };

  downloadPDF= async () => {
    this.setState({ ...this.state, emailloader: true });
    await this.handlePdf();
  }

  handlePdf = async () => {
    // try {
      let chartId = this.state.chartData?.widgetId;
      let widgetName = this.state.chartData
        ? this.state.chartData.widgetName
        : "Histogram";
       var pdf = new jsPDF('pt', 'px',[ 595.28,  841.89]);
      let ids = [
        "c1" + chartId,
        "c2" + chartId,
        "c3" + chartId,
        "c4" + chartId,
      ];
      for (let i = 0; i < ids.length; i++) {
        const input = document.getElementById(ids[i]);
        const canvas = await html2canvas(input);
        const imgData = canvas.toDataURL("image/png");
        pdf.addPage();
        pdf.setFillColor(24, 26, 26);
        pdf.rect(0, 0, 595.28,  841.89,"F");
        pdf.addImage(imgData, "PNG", 100,60);
      }
      pdf.deletePage(1);
      pdf.save(widgetName+".pdf");
     
      
      this.setState({ ...this.state, emailloader: false });
    // } catch (err) {
    //   console.error(err);
    //   this.setState({ ...this.state, emailloader: false });
    // }
  };
  refreshTextNarative=(text,widgetId)=> {
    this.props.refreshTextNarative&&this.props.refreshTextNarative(text,widgetId);
  }
   editWidgetOpen = (data) => {
    this.refs.childUpdateWidget.editWidgetdOpen(data);
  };
  updateChartData = async (data) => {
    await this.fetchReportsByPagination(data.dashboardId, data.widgetId);
    this.refs.childUpdateWidget.updateReportPopupClose();
  };
  render() {
    const chartData = this.state.chartData ? this.state.chartData : {};
    const userId = parseInt(secureLocalStorage.getItem("loginUserId"));
    const CreatedDate = moment(chartData.createdDate).format("DD-MMM-yyyy");
    if (!this.state.isReportLoaded) {
      return <SkeletonReport />;
    }
    else if(chartData.isCustomFieldDeleted||chartData.isImpactDeleted){
      return (
        <div>
           <ul className="WidgetActions">
           {this.props.isTenentAdmin ||
              chartData.createdBy == userId ||
              (this.props.selectedDashboard &&
                this.props.selectedDashboard.createdBy == userId) ? (
                !this.props.isFreezeDS && (
                                    <li onClick={this.openWidgetDeletePopup}>
                                      <a className="bgRed">
                                        <img src={Images.TRASH} alt="Trash" width="13" />
                                      </a>
                                    </li>
                                  )
              ) : (
                ""
              )}
           </ul>
          <h4 className="wgTitle">
          Associated Dataset's Impact/Custom fields might been deleted or revoked
          </h4>
          <Popup
            show={this.state.openDeleteModelFlag}
            popupClass={"popup-content"}
          >
            {this._Loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}
            <div className="deleteModelCont">
              <h3>Are you sure you want to delete this report?</h3>
              <div className="btnCont">
                <button
                  onClick={() => this.removeWidget(chartData)}
                  className="deleteBtn"
                  type="button"
                >
                  Yes
                </button>
                <button
                  onClick={this.closeWidgetDeletePopup}
                  className="cancelBtn"
                  type="button"
                >
                  No
                </button>
              </div>
            </div>
          </Popup>
        </div>
      );
    }else if(chartData.notValidPrimeDataset){
      return (
        <div>
           <ul className="WidgetActions">
           {this.props.isTenentAdmin ||
              chartData.createdBy == userId ||
              (this.props.selectedDashboard &&
                this.props.selectedDashboard.createdBy == userId) ? (
                !this.props.isFreezeDS && (
                                    <li onClick={this.openWidgetDeletePopup}>
                                      <a className="bgRed">
                                        <img src={Images.TRASH} alt="Trash" width="13" />
                                      </a>
                                    </li>
                                  )
              ) : (
                ""
              )}
           </ul>
          <h4 className="wgTitle">
            Cannot load report as Prime settings have been changed for Workstream.
          </h4>
          <Popup
            show={this.state.openDeleteModelFlag}
            popupClass={"popup-content"}
          >
            {this._Loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}
            <div className="deleteModelCont">
              <h3>Are you sure you want to delete this report?</h3>
              <div className="btnCont">
                <button
                  onClick={() => this.removeWidget(chartData)}
                  className="deleteBtn"
                  type="button"
                >
                  Yes
                </button>
                <button
                  onClick={this.closeWidgetDeletePopup}
                  className="cancelBtn"
                  type="button"
                >
                  No
                </button>
              </div>
            </div>
          </Popup>

        </div>
      );
    }else if(chartData.isTaskModuleDisabled){
          return (
            <div>
               <ul className="WidgetActions">
               {this.props.isTenentAdmin ||
                  chartData.createdBy == userId ||
                  (this.props.selectedDashboard &&
                    this.props.selectedDashboard.createdBy == userId) ? (
                      !this.props.isFreezeDS && (
                        <li onClick={this.openWidgetDeletePopup}>
                          <a className="bgRed">
                            <img src={Images.TRASH} alt="Trash" width="13" />
                          </a>
                        </li>
                      )
                  ) : (
                    ""
                  )}
               </ul>
              <h4 className="wgTitle">
              Cannot load report as Task Module settings have been changed for Tenant. Please contact administrator.
              </h4>
              <Popup
                show={this.state.openDeleteModelFlag}
                popupClass={"popup-content"}
              >
                {this._Loader ? (
                  <span className="MatTableSpinner">
                    <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
                  </span>
                ) : null}
                <div className="deleteModelCont">
                  <h3>Are you sure you want to delete this report?</h3>
                  <div className="btnCont">
                    <button
                      onClick={() => this.removeWidget(chartData)}
                      className="deleteBtn"
                      type="button"
                    >
                      Yes
                    </button>
                    <button
                      onClick={this.closeWidgetDeletePopup}
                      className="cancelBtn"
                      type="button"
                    >
                      No
                    </button>
                  </div>
                </div>
              </Popup>
    
            </div>
          );
        }else{
    return (
      <div id="capture">
        {this.state.loader ? (
          <span className="MatTableSpinner">
            <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
          </span>
        ) : null}
        {this.state.emailloader ? (
          <span className="MatTableSpinner">
            <MuiThemeProvider theme={theme}>
              <LinearProgress color="secondary" />
            </MuiThemeProvider>
            <span>Exporting Files... </span>
          </span>
        ) : null}
        {this.state.visible && (
          <Window
            title={chartData.dataSource}
            onClose={this.closeToggleClose}
            className="statusWindow"
            initialLeft={350}
            initialTop={200}
            initialWidth={1000}
            initialHeight={490}

          >
            <div className="tblCont dataGrids">
              <ViewActionRiskDataset
                chartData={chartData}
                isFreezeDS={this.props.isFreezeDS}
              ></ViewActionRiskDataset>
            </div>
          </Window>
        )}
        {this.props.expandIcon && (
          <div className="expandView">
            <a
              className="expand"
              onClick={() =>
                this.props.changeLineChartWidth(chartData.widgetId)
              }
            >
              <img src={Images.VIEWFULLVIEW} alt="Expand" width="10" />
            </a>
            <a
              className="shrink"
              onClick={() =>
                this.props.changeLineChartWidth(chartData.widgetId)
              }
            >
              <img src={Images.SHRINK} alt="Expand" width="10" />
            </a>
          </div>
        )}
        {this.props.viewDataSetIcon && (
          <ul className="viewDataset WidgetActions">
            <TextNarrative
              chartInputs={chartData}
              refreshTextNarative={this.refreshTextNarative}
              isFreezeDS={this.props.isFreezeDS}
            />
            <li
              title="View Dataset"
              onClick={() => this.ViewDataSet(chartData)}
            >
              <a>
                <img src={Images.VIEWLIST} alt="View Dataset" width="14" />
              </a>
            </li>
          </ul>
        )}
        {this.props.flag ? (
          <ul className="WidgetActions">
            {this.props.isTenentAdmin ||
                          chartData.createdBy == userId ||
                          (this.props.selectedDashboard &&
                            this.props.selectedDashboard.createdBy == userId)
                            ? !this.props.isFreezeDS && (
                                <li onClick={() => this.editWidgetOpen(chartData)}>
                                  <a>
                                    <img src={Images.EDITICON} alt="Edit" width="14" />
                                  </a>
                                </li>
                              )
                            : ""}
            <TextNarrative
              chartInputs={chartData}
              refreshTextNarative={this.refreshTextNarative}
              isFreezeDS={this.props.isFreezeDS}
            />
            <li
              title="View Dataset"
              onClick={() => this.ViewDataSet(chartData)}
            >
              <a>
                <img src={Images.VIEWLIST} alt="View Dataset" width="14" />
              </a>
            </li>
            {this.props.isFreezeDS ? (
              ""
            ) : (
              <li
                title="Add to home"
                onClick={() => this.moveToHome(chartData)}
              >
                <a>
                  <img src={Images.HOME} alt="Download" width="14" />
                </a>
              </li>
            )}
            {/* <li onClick={this.handleDownloadImage}>
              <a>
                  <img src={Images.DOWNLOAD} alt="Download" width="14" />
              </a>
            </li>
            {/* <li onClick={this.downloadPDF}>
              <a>
                <img src={Images.PDF} alt="Download" width="14" />
              </a>
            </li> */}
            {/* {this.props.isFreezeDS ? (
              ""
            ) : (
              <li onClick={() => this.openAddToCart(chartData.widgetId)}>
                <a>
                  <img src={Images.SHARE} alt="Download" width="14" />
                </a>
              </li>
            )} */}
            
            {/* <li>
              <Dropdown
                menuAlign="right"
                title="Mail"
                id="dropdown-menu-align-right"
              >
                <Dropdown.Toggle>
                  <a>
                    <img src={Images.EMAIL} alt="Share" width="14" />
                  </a>
                </Dropdown.Toggle>
                <Dropdown.Menu className="filterList emailBox">
                  <div className="filterBox">
                    <div className="dateRange">
                      <div className="dateCont">
                        <h6>Email</h6>
                        <input
                          type="email"
                          autoComplete="off"
                          value={this.state.emailId}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              emailId: e.target.value,
                            })
                          }
                        />
                      </div>
                      <div className="dateCont">
                        <h6>Message</h6>
                        <textarea
                          value={this.state.message}
                          autoComplete="off"
                          onChange={(e) =>
                            this.setState({
                              message: e.target.value,
                            })
                          }
                        ></textarea>
                        <Dropdown.Item
                          as="button"
                          onClick={() => this.shareFile(chartData.widgetId)}
                        >
                          SEND
                        </Dropdown.Item>
                      </div>
                    </div>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </li> */}

            {this.props.isTenentAdmin ||
            chartData.createdBy == userId ||
            (this.props.selectedDashboard &&
              this.props.selectedDashboard.createdBy == userId) ? (
              !this.props.isFreezeDS && (
                                  <li onClick={this.openWidgetDeletePopup}>
                                    <a className="bgRed">
                                      <img src={Images.TRASH} alt="Trash" width="13" />
                                    </a>
                                  </li>
                                )
            ) : (
              ""
            )}
          </ul>
        ) : (
          <ul className="WidgetActions">
            {/* <li
              title="Remove from home"
              onClick={() => this.removeFromHome(chartData)}
            >
              <a>
                <img src={Images.DELETEFROMHOME} alt="Download" width="14" />
              </a>
            </li> */}
          </ul>
        )}

        <div id="histogramChartCont1">
          <div id={"cg" + chartData.widgetId} >
            {/* <small className="createdDate">{CreatedDate}</small> */}
            <div className="histogramChartCont" id={"c1" + chartData.widgetId}>
              <h2> Pre-Mitigated - Threat</h2>
              <HistogramChart
                {...this.props}
                isOpportunity={false}
                histogramResponse={
                  chartData.nonMitigatedMonteCarloResponse
                    ? chartData.nonMitigatedMonteCarloResponse.histogramResponse
                    : {}
                }
              />
            </div>
            <div className="histogramChartCont" id={"c2" + chartData.widgetId}>
              <h2> Post-Mitigated - Threat</h2>
              <HistogramChart
                {...this.props}
                isOpportunity={false}
                histogramResponse={
                  chartData.mitigatedMonteCarloResponse
                    ? chartData.mitigatedMonteCarloResponse.histogramResponse
                    : {}
                }
              />
            </div>

            {/* //oppertunities */}
            <div className="histogramChartCont" id={"c3" + chartData.widgetId}>
              <h2> Unrealised-Opportunity</h2>

              <HistogramChart
                {...this.props}
                isOpportunity={true}
                histogramResponse={
                  chartData.nonMitigatedMonteCarloResponse
                    ? chartData.nonMitigatedMonteCarloResponse
                        .histogramOpportunityResponse
                      ? chartData.nonMitigatedMonteCarloResponse
                          .histogramOpportunityResponse
                      : {}
                    : {}
                }
              />
            </div>
            <div className="histogramChartCont" id={"c4" + chartData.widgetId}>
              <h2> Realised - Opportunity</h2>
              <HistogramChart
                {...this.props}
                isOpportunity={true}
                histogramResponse={
                  chartData.mitigatedMonteCarloResponse
                    ? chartData.mitigatedMonteCarloResponse
                        .histogramOpportunityResponse
                      ? chartData.mitigatedMonteCarloResponse
                          .histogramOpportunityResponse
                      : {}
                    : {}
                }
              />
            </div>
            {/* // */}
            </div>
            <div className="histogramChartCont tornodoAnalyticsChart">
              <h2>
                Pre-Mitigated - Threat : Probability and Impact ranking
                {this.state.chartData.nonMitigatedMonteCarloResponse
                  ? " - (" +
                    this.state.chartData.nonMitigatedMonteCarloResponse
                      .histogramResponse.impactName +
                    " )"
                  : ""}
              </h2>
              <TornadoChart
                {...this.props}
                isOpportunity={false}
                tornodoResponse={
                  chartData.nonMitigatedMonteCarloResponse
                    ? chartData.nonMitigatedMonteCarloResponse.tornodoResponses
                    : {}
                }
              />
            </div>
            <div className="histogramChartCont tornodoAnalyticsChart" >
              <h2>
                Post-Mitigated - Threat : Probability and Impact ranking
                {this.state.chartData.nonMitigatedMonteCarloResponse
                  ? " - (" +
                    this.state.chartData.nonMitigatedMonteCarloResponse
                      .histogramResponse.impactName +
                    " )"
                  : ""}
              </h2>
              <TornadoChart
                {...this.props}
                isOpportunity={false}
                tornodoResponse={
                  chartData.mitigatedMonteCarloResponse
                    ? chartData.mitigatedMonteCarloResponse.tornodoResponses
                    : {}
                }
              />
            </div>
            {/* //oppertunities */}

            <div className="histogramChartCont tornodoAnalyticsChart" >
              <h2>
                Unrealised - Opportunity : Probability and Impact ranking
                {this.state.chartData.nonMitigatedMonteCarloResponse
                  ? " - (" +
                    this.state.chartData.nonMitigatedMonteCarloResponse
                      .histogramResponse.impactName +
                    " )"
                  : ""}
              </h2>
              <TornadoChart
                {...this.props}
                isOpportunity={true}
                tornodoResponse={
                  chartData.nonMitigatedMonteCarloResponse
                    ? chartData.nonMitigatedMonteCarloResponse
                        .tornodoOpportunityResponses
                      ? chartData.nonMitigatedMonteCarloResponse
                          .tornodoOpportunityResponses
                      : {}
                    : {}
                }
              />
            </div>
            <div className="histogramChartCont tornodoAnalyticsChart" >
              <h2>
                Realised - Opportunity : Probability and Impact ranking
                {this.state.chartData.nonMitigatedMonteCarloResponse
                  ? " - (" +
                    this.state.chartData.nonMitigatedMonteCarloResponse
                      .histogramResponse.impactName +
                    " )"
                  : ""}
              </h2>
              <TornadoChart
                {...this.props}
                isOpportunity={true}
                tornodoResponse={
                  chartData.mitigatedMonteCarloResponse
                    ? chartData.mitigatedMonteCarloResponse
                        .tornodoOpportunityResponses
                      ? chartData.mitigatedMonteCarloResponse
                          .tornodoOpportunityResponses
                      : {}
                    : {}
                }
              />
            </div>
            <div className="histogramChartCont" >
              <h2>
                Pre-Mitigated - Threat : Probability and Impact ranking
                {this.state.chartData.nonMitigatedMonteCarloResponse
                  ? " - (" +
                    this.state.chartData.nonMitigatedMonteCarloResponse
                      .histogramResponse.impactName +
                    " )"
                  : ""}
              </h2>
              <FullTornadoChart
                {...this.props}
                tornodoResponse={
                  chartData.nonMitigatedMonteCarloResponse
                    ? chartData.nonMitigatedMonteCarloResponse
                        .nonMitigatedFullTornodoResponses
                    : []
                }
              />
            </div>
            <div className="histogramChartCont" >
              <h2>
                Post-Mitigated - Threat : Probability and Impact ranking
                {this.state.chartData.nonMitigatedMonteCarloResponse
                  ? " - (" +
                    this.state.chartData.nonMitigatedMonteCarloResponse
                      .histogramResponse.impactName +
                    " )"
                  : ""}
              </h2>
              <FullTornadoChart
                {...this.props}
                tornodoResponse={
                  chartData.mitigatedMonteCarloResponse
                    ? chartData.mitigatedMonteCarloResponse
                        .mitigatedFullTornodoResponses
                    : []
                }
              />
            </div>
            {/* //oppertunities */}

            <div className="histogramChartCont" >
              <h2>
                Unrealised - Opportunity : Probability and Impact ranking
                {this.state.chartData.nonMitigatedMonteCarloResponse
                  ? " - (" +
                    this.state.chartData.nonMitigatedMonteCarloResponse
                      .histogramResponse.impactName +
                    " )"
                  : ""}
              </h2>
              <FullTornadoChart
                {...this.props}
                isOpportunity={true}
                tornodoResponse={
                  chartData.nonMitigatedMonteCarloResponse
                    ? chartData.nonMitigatedMonteCarloResponse
                        .nonMitigatedOppFullTornodoResponses
                    : []
                }
              />
            </div>
            <div className="histogramChartCont" >
              <h2>
                Realised - Opportunity : Probability and Impact ranking
                {this.state.chartData.nonMitigatedMonteCarloResponse
                  ? " - (" +
                    this.state.chartData.nonMitigatedMonteCarloResponse
                      .histogramResponse.impactName +
                    " )"
                  : ""}
              </h2>
              <FullTornadoChart
                {...this.props}
                isOpportunity={true}
                tornodoResponse={
                  chartData.mitigatedMonteCarloResponse
                    ? chartData.mitigatedMonteCarloResponse
                        .mitigatedOppFullTornodoResponses
                    : []
                }
              />
            </div>
         
        </div>
        <ReportUpdate
                    chartData={chartData}
                    ref="childUpdateWidget"
                    updateChartData={this.updateChartData}
                  />
        <Popup
          show={this.state.openDeleteModelFlag}
          popupClass={"popup-content"}
        >
          {this.state.loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}
          <div className="deleteModelCont">
            <h3>Are you sure you want to delete this report?</h3>
            <div className="btnCont">
              <button
                onClick={() => this.removeWidget(chartData)}
                className="deleteBtn"
                type="button"
              >
                Yes
              </button>
              <button
                onClick={this.closeWidgetDeletePopup}
                className="cancelBtn"
                type="button"
              >
                No
              </button>
            </div>
          </div>
        </Popup>
        <Popup show={this.state.showAddToCart} popupClass={"popup-content"}>
          <AddToCart
            {...this.props}
            closeAddToCart={() => this.closeAddToCart()}
            cartViewDetailsId={this.state.cartViewDetails}
            cartViewType={this.state.cartViewType}
          />
        </Popup>
      </div>
    );
  }
}
}
